import { Lang } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    pageHeaderText: 'Best of the best',
    correctAnswers_one: '{{ count }} correct answer',
    correctAnswers: '{{ count }} correct answers',
    correctness: '{{ percentage }} correctness',
    allAnswers_one: '{{ count }} question answered ({{ percentage }})',
    allAnswers: '{{ count }} questions answered ({{ percentage }})',
    options: ['Most correct answers', 'Top correctness', 'Most answers'],
    info: [
      'Sorted by number of questions correctly answered by an individual user.',
      'Sorted by ratio of correct answers to all questions answered by an individual user.',
      'Sorted by number of all questions answered by an individual user.',
    ],
  },
}
